import { render, staticRenderFns } from "./BayesCaculator.vue?vue&type=template&id=0d60478c&scoped=true&"
import script from "./BayesCaculator.vue?vue&type=script&lang=js&"
export * from "./BayesCaculator.vue?vue&type=script&lang=js&"
import style0 from "./BayesCaculator.vue?vue&type=style&index=0&id=0d60478c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d60478c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\web\\V-LAB\\project\\bayes-vue2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d60478c')) {
      api.createRecord('0d60478c', component.options)
    } else {
      api.reload('0d60478c', component.options)
    }
    module.hot.accept("./BayesCaculator.vue?vue&type=template&id=0d60478c&scoped=true&", function () {
      api.rerender('0d60478c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BayesCaculator.vue"
export default component.exports